export default {
    Interview: {
        alertStartMsg: "面试尚未开始，请耐心等待",
        alertEndMsg: "面试已结束",
    },
    Login: {
        login: "登录",
        loginPlaceholder: "登录ID",
        detectionTips: "登录前，请先进行",
        detectionButton: "设备检测",
        loginWarningMsg: "登录ID不能为空",
        loginFailMsg: "登录ID有误或登录链接有误，请重试",
        getLoginDataFailMsg: "登录链接有误，请重试",
    },
    Message: {
        title: "身份核对",
        name: "姓名",
        gender: "性别",
        time: "面试时间",
        tips: "点击进入面试间后，面试官将能看到你的状态，请稍作等待，面试官会稍后进入面试间",
        btnStatus: ["尚未开始，请等待", "分钟后开始", "秒", "进入面试间", "面试已结束"],
        enterStartAlert: "面试尚未开始，请耐心等待",
        enterEndAlert: "面试已结束",
    },
};
